
import React from 'react';

export default function TeamListInformation() 
{
    return ( 
        <> 
            <div class="alert alert-light mt-2" role="alert">
                <small>
                    <p>So now you are ready to share the load! Fortunately there are people that have our same goals and are ready to help. 
                    This List will help you all coordinate your activities, quickly identify blockers, and evaluate progress towards
                    your team goals.</p>

                    <div class="row">
                        <div class="col-1">
                            <a href="#"><img class="card-icon" src="./checklist.svg" alt="list" border="0"/></a>
                        </div>
                        <div class="col">
                            Action List
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-1">
                            <a href="#"><img class="card-icon" src="./images/stg.svg" alt="stgs" border="0"/></a>
                        </div>
                        <div class="col">
                            The Team's current, shared Short-Term Goals and all Team Member Action assignments.
                        </div>
                    </div>

                    <div class="row mt-1">
                        <div class="col-1">
                            <a href="#"><img class="card-icon" src="./images/users.svg" alt="users" border="0"/></a>
                        </div>
                        <div class="col">
                            List of all Team Members including the number of active Team Action Assignments.
                        </div>
                    </div>

                    <div class="row mt-1">
                        <div class="col-1">
                            <a href="#"><img class="card-icon" src="./images/invitation.svg" alt="invite" border="0"/></a>
                        </div>
                        <div class="col">
                            Team administrators can quickly send Team Invitations to Users by clicking this icon above and entering their username, 
                            phone number, or email. <em>If the invitee is not currently a Call to Action List User, an Email or SMS Invitation will be sent. </em>
                            Users can then decide whether to accept the invitation.
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-1">
                        <a href="#"><img class="card-icon" src="./images/history.svg" alt="history" border="0"/></a>
                        </div>
                        <div class="col">
                            Team History. Both Users and Actions also have their own history events.
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-1">
                            <a href="#"><img class="card-icon" src="./images/settings.svg" alt="settings" border="0"/></a>
                        </div>
                        <div class="col">
                            Team Settings
                        </div>
                    </div>

                    <div class="mt-2">
                        Enter a new action item above and click "Create" to get started!
                    </div>
                    
                </small>
            </div>
        </> 
    );
}

//alert-info